import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-who-is-in',
  templateUrl: './who-is-in.component.html',
  styleUrls: ['./who-is-in.component.scss']
})
export class WhoIsInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
